import { apiClient } from "../client";
import handleError from "../../utilities/api-helpers/handleError";
import tcWrap from "../../utilities/generic-helpers/tcWrap";

export const terms = () =>
  tcWrap(async () => {
    const data = await apiClient.get("/content/term_and_condition").catch(handleError);
    return data;
  });
